import React from 'react';
import { Doughnut } from 'react-chartjs-2';

import { amber, deepOrange, orange, yellow } from '@mui/material/colors';

import DemoTour from 'main/components/panel/DemoTour';
import MarkdownElement from 'utils/MarkdownElement';

const yellow600 = yellow['600'];
const amber500 = amber['500'];
const orange300 = orange['300'];
const deepOrange700 = deepOrange['700'];

const HELP_TEXT = `
**Agent Security Scanner**

Several simple steps to protect your Linux or windows server
1. Choose your **OS** and Install **Agent Scanner** package on your server
2. Add config with API-key
3. Review your scan results in "API Scan Reports" tab

Follow steps below`;

const getDemoGraph = () => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
            <div style={{ width: '200px', height: '100px', marginRight: '40px' }}>
                <Doughnut
                    type="doughnut"
                    data={{
                        labels: ['Debian', 'RedHat', 'CentOS', 'Exploits'],
                        datasets: [
                            {
                                data: [300, 50, 150, 100],
                                backgroundColor: [yellow600, amber500, orange300, deepOrange700]
                            }
                        ]
                    }}
                    options={{
                        cutoutPercentage: 60,
                        legend: {
                            display: true,
                            position: 'left'
                        }
                    }}
                    animation={{
                        animateScale: true
                    }}
                />
            </div>
            <div style={{ marginLeft: '10px' }}>
                <MarkdownElement text={HELP_TEXT} />
            </div>
        </div>
    );
};

export default () => (
    <DemoTour
        hideMainButton={true}
        className="margin-bottom-16"
        demoName="vulnersScannerHelp"
        demoMessage={getDemoGraph()}
    />
);
